import styled from 'styled-components';
import { pxToRem } from 'modules/spacing';
import { theme } from 'modules/tetrisTheme';
export const Container = styled.div `
  display: ${(props) => (props.$stretch ? 'flex' : 'inline-flex')};
  justify-content: center;
`;
export const Dot = styled.div `
  position: relative;
  padding: 0;
  background-color: ${theme.swatches.gray[200]};
  border: 0;

  button:focus-visible > & {
    box-shadow: ${(props) => (props.$selected ? `0 0 0 ${pxToRem(2)} color-mix(in srgb, ${theme.swatches.gray[700]}, transparent 80%)` : 'none')};
  }

  &,
  &::before {
    width: ${theme.spacing.md};
    height: ${theme.spacing.md};
    border-radius: ${theme.borderRadius.circle};
  }

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    background-color: ${(props) => (props.$selected ? theme.swatches.warm[500] : 'transparent')};
  }
`;
export const StyledButton = styled.button `
  padding: ${theme.spacing.sm};
  appearance: none;
  background-color: transparent;
  border: 0;

  &:first-child {
    padding-left: 0;
  }

  &:last-child {
    padding-right: 0;
  }

  &:focus-visible {
    outline: none;
  }
`;
